import React from 'react';

interface ICustomSwitchButton {
    title: string;
    checked: boolean;
    onChange: () => void;
}

const CustomSwitchButton = ({ title, checked, onChange }: ICustomSwitchButton) => {

    return (
        <label className="flex items-center justify-between w-full p-1 cursor-pointer">
            <div className="text-gray-700 font-medium">{title}</div>
            <div className="relative">
                <input
                    type="checkbox"
                    className="sr-only"
                    checked={checked}
                    onChange={onChange}
                />
                <div className={`w-10 h-6 ${checked ? "bg-primary" : "bg-gray-400"} rounded-full shadow-inner transition-transform duration-300 ease-in-out transform`}>
                    <div
                        className={`absolute w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ease-in-out transform ${checked ? 'translate-x-full' : ''
                            }`}
                    ></div>
                </div>
            </div>
        </label>
    );
};

export default CustomSwitchButton;
